import React from 'react';
import IconComponent from 'ui/src/components/Icon';
import Image from 'ui/src/components/Image';

interface Props {
  name: string;
  image: string;
  role: string;
  yearsOfExperience: number;
  countryFlag: string;
}

export default function Talent({ name, image, role, yearsOfExperience, countryFlag }: Props) {
  return (
    <div className="bg-site-neutrals-0/10 flex min-w-[12.5rem] overflow-clip rounded-lg">
      <div className="w-14 overflow-hidden rounded-r [background-image:linear-gradient(180deg,_theme(colors.site.neutrals.100/0.8),_theme(colors.site.neutrals.25/0.8)),_linear-gradient(theme(colors.site.accent.900/0.1))]">
        <Image src={image} alt={name} width={56} height={56} className="origin-bottom" />
      </div>
      <div className="flex flex-1 flex-col px-1.5 py-2">
        <div className="mb-0.5 flex">
          <span className="text-site-neutrals-100 flex-1 text-[0.625rem] leading-4">{name}</span>
          <Image src={countryFlag} alt="" width={14} height={14} className="object-contain" />
        </div>
        <span className="text-site-neutrals-0 mb-px text-[0.375rem] font-bold uppercase leading-[0.625rem] tracking-[20%]">
          {role}
        </span>
        <span className="text-site-neutrals-100 flex items-center gap-0.5">
          <IconComponent iconName="VerifiedFilled" className="bg-site-neutrals-100 !size-2.5" size="Glyph" />
          <span className="text-[0.5rem] leading-[0.5rem]">{yearsOfExperience} years of experience</span>
        </span>
      </div>
    </div>
  );
}
